/* eslint-env jquery, browser */
import auth0 from 'auth0-js';
import metrics from 'modules/metrics';
import bus from 'modules/npm-component/bus';

const AUTH0_AUDIENCE = window.APP_CONFIG.AUTH0_AUDIENCE;
const AUTH0_CLIENT_ID = window.APP_CONFIG.AUTH0_CLIENT_ID;
const AUTH0_DOMAIN = window.APP_CONFIG.AUTH0_DOMAIN;
const AUTH0_SCOPE = window.APP_CONFIG.AUTH0_SCOPE;
const AUTH0_CALLBACK_URL = window.APP_CONFIG.AUTH0_CALLBACK_URL;

export const auth0WebAuth = new auth0.WebAuth({
  domain: AUTH0_DOMAIN,
  clientID: AUTH0_CLIENT_ID,
  audience: AUTH0_AUDIENCE,
  scope: AUTH0_SCOPE,
  redirectUri: AUTH0_CALLBACK_URL,
  responseType: 'code'
});

auth0WebAuth.client.getSSOData(false, (err, data) => {
  bus.emit('sso', data);
});

export const login = () => {
  metrics.lib().track('click:signin', { category: 'button' });
  window.location.href = '/auth/login';
};

window.login = login;

export const signup = (btn, additionalData = {}) => {
  const data = { category: 'button' };
  const redirectUri = '/signup?';
  const { refPage } = additionalData;
  if (btn) {
    data.trackData = $(btn).data('track');
  }
  const queryParams = Object.keys(refPage || []).map(
    key => `${key}=${encodeURIComponent(refPage[key])}`
  );
  window.location.href = `${redirectUri}${queryParams.join('&')}&signUpData=${encodeURIComponent(
    JSON.stringify(data)
  )}`;
};

window.signup = signup;



// WEBPACK FOOTER //
// ./src/modules/boot/sso/client.js